import { Typography } from '@mui/material';
import { FC } from 'react';
import { CarTopLabelStyle } from './useStyles';

interface CarTopLabelProps {
  title: string;
  customTextStyle?: React.CSSProperties;
}
const CarTopLabel: FC<CarTopLabelProps> = ({ title, customTextStyle }) => {
  return (
    <Typography sx={{ ...CarTopLabelStyle, ...customTextStyle }}>
      {title}
    </Typography>
  );
};

export default CarTopLabel;
